export default "__VITE_ASSET__HnRrO4iL__"